module.exports = __webpack_public_path__ + "static/digital38defcaf0c45a7bceefaa1f399a5270c8.png";